import { createSlice } from '@reduxjs/toolkit';
import { addGenericRequest, findGenericRequestsByStatus, getGenericRequest, saveGenericRequest, signGenericRequest } from './GenericRequestApi';
import { addGenericStateListBuilders, addGenericStateSingleBuilders } from '../slice';
import { defaultGenericState, GenericState } from '../model';


export enum GenericRequestStatus {
    DRAFT = 'DRAFT',
    INITIAL = 'INITIAL',
    APPROVED = 'APPROVED',
    ISSUED = 'ISSUED',
    REJECTED = 'REJECTED',
}

export interface GenericRequestApprover {
    toBeApprovedByDisplay: string;
    approved: boolean;
}
export interface GenericRequest {
    frontendCorrelationKey: string | undefined;
    requestType: string | undefined;
    templateId: string | undefined;
    credentialJson: any | undefined;
    additionalJson: AdditionalDetails | undefined;
    walletUrl: string | undefined;
    createdAt: Date | undefined;
    status?: GenericRequestStatus;
    approvers?: GenericRequestApprover[];
    allowedActions: string[];
}


export interface AdditionalDetails {
    status: GenericRequestStatus;
    polisNummer: string;
    familyName: string;
    given_name: string;
    dateOfBirth: string;
    waardeBeleggingen: number;
    verwachtePensioenuitkeringPerJaar: number;
}

export interface GenericRequestState extends GenericState<GenericRequest> {
}

export const genericRequestSlice = createSlice({
    name: 'genericRequest',
    initialState: defaultGenericState,
    reducers: {},
    extraReducers: builder => {
        addGenericStateSingleBuilders(builder, getGenericRequest);
        addGenericStateSingleBuilders(builder, addGenericRequest);
        addGenericStateSingleBuilders(builder, saveGenericRequest);
        addGenericStateSingleBuilders(builder, signGenericRequest);
        addGenericStateListBuilders(builder, findGenericRequestsByStatus);
    },
});


export function getCompanyName(genericRequest: GenericRequest | undefined): string {
    if (genericRequest === undefined) return "";
    let value = genericRequest.credentialJson?.PersonIdentificationData?.credential?.vc?.credentialSubject?.legal_person_name;
    if (value !== undefined) return value;
    value = genericRequest.credentialJson?.KVKRegistration?.credential?.vc?.credentialSubject?.naam;
    if (value !== undefined) return value;
    value = genericRequest.credentialJson?.Oprichtingsakte?.credential?.vc?.credentialSubject?.statutaireNaamVennootschap;

    if (value !== undefined) return value;
    return "Unknown company"
}

export function isSigningAllowed(genericRequest: GenericRequest | undefined): boolean {
    if ((genericRequest === undefined) || (genericRequest.allowedActions === undefined)) {
        return false;
    }
    if (genericRequest.allowedActions.includes('SIGN')) {
        return true;
    }
    return false;
}
